import axios from "axios";
import initializeAxios from "../util/Axios";

class SettingServices {
    constructor() {
        initializeAxios();
    }

    async addSetting({
        name,
        slug,
        title,
        keywords,
        description,
        script,
        contentOne,
        contentTwo,
        contentThree,
        contentFour,
        contentFive,
        contentSix,
        seoTitle,
        banners,
        logo
    }) {
        const response = await axios.post("/api/setting/add", {
            name,
            slug,
            title,
            keywords,
            description,
            script,
            contentOne,
            contentTwo,
            contentThree,
            contentFour,
            contentFive,
            contentSix,
            seoTitle,
            banners,
            logo
        });

        return response;
    }

    async editSetting({
        settingId,
        name,
        slug,
        title,
        keywords,
        description,
        script,
        contentOne,
        contentTwo,
        contentThree,
        contentFour,
        contentFive,
        contentSix,
        seoTitle,
        banners,
        logo
    }) {
        const response = await axios.put("/api/setting/update", {
            settingId,
            name,
            slug,
            title,
            keywords,
            description,
            script,
            contentOne,
            contentTwo,
            contentThree,
            contentFour,
            contentFive,
            contentSix,
            seoTitle,
            banners,
            logo
        });

        return response;
    }

    async getSettingDetails() {
        const response = await axios.get("/api/setting/details");
        return response;
    }

    async uploadToS3(data) {
        const formData = new FormData();
        for (let key in data) {
            formData.append(key, data[key]);
        }
        const response = await axios.post("/api/util/uploadimage", formData);
        return response.data;
    }

}

export default new SettingServices();